<template>
  <div class="content">
    <div class="time-box">
      <div class="flex-ct column time-item time-item1">
        <div class="flex-ct column time-con">
          <span>昆山非凡生命科学产业创新中心开园</span>
          <img src="@/assets/icon/h1.png" alt="" />
        </div>
        <div class="time-dot"></div>
        <div class="time-text">2022年11月25日</div>
      </div>
      <div
        class="flex-ct column time-item time-item2"
        style="flex-direction: column-reverse"
      >
        <div class="flex-ct column time-con">
          <span>
            昆山生命科学产业园合作发展交流会暨领致生物科技(昆山)有限公司开业仪式举行
          </span>
          <img src="@/assets/icon/h2.png" alt="" />
        </div>
        <div class="time-dot"></div>
        <div class="time-text">2023年09月19日</div>
      </div>
      <div class="flex-ct column time-item time-item3">
        <div class="flex-ct column time-con">
          <span>2024湖区生命健康科学家大会举办</span>
          <img src="@/assets/icon/h3.png" alt="" />
        </div>
        <div class="time-dot"></div>
        <div class="time-text">2024年01月14日</div>
      </div>
      <div class="time-line"></div>
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.content {
  min-width: 100%;
  min-height: 700px;
  background: #fff;
  overflow: overlay;
}

.time-box {
  position: relative;
  width: calc(400px * 3);
  min-width: 100%;
  height: 700px;
  gap: 60px;

  img {
    width: 288px;
  }
}

.time-item1 {
  bottom: calc(50% - 55px);
}
.time-item2 {
  left: 400px;
  top: calc(50% - 52.5px);
}
.time-item3 {
 
  left: 800px;
  bottom: calc(50% - 55px);
}

.time-item {
  position: absolute;
  z-index: 99;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  gap: 20px;
  .time-con {
    width: 288px;
    // height: 240px;
    padding: 12px 21px;
    text-align: start;
    border: 1px solid #d92629;
    border-radius: 4px;
  }
}

.time-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ffffff;
  border: 3px solid #d92629;
}

.time-line {
  position: absolute;
  top: calc(50% - 2px);
  width: 100%;
  height: 4px;
  background: #d92629;
}

/* 当屏幕宽度小于或等于 600px 时 */
@media (max-width: 600px) {
  .time-item {
    font-size: 13px;
  }
  .time-item .time-con {
    width: 200px;
    padding: 12px;
  }
  .time-box {
    width: calc(230px * 3);
  }
  .time-box img{
    width: 200px;
  }
  .time-item1 {
    bottom: calc(50% - 52px);
  }
  .time-item2 {
    left: 200px;
    top: calc(50% - 52.5px);
  }
  .time-item3 {
    left: 400px;
    bottom: calc(50% - 52px);
  }
  .time-box {
    height: 500px;
  }
}
</style>
